<template>
  <div class="form__group form__group--move" :class="[getTouchedClass,getExternalClass]">
    <div class="form__input" :class="isFocused">
      <textarea
        :id="id"
        v-model="currentValue"
        :required="required"
        :placeholder="placeholder"
        autocomplete="off"
        @input="updateValue($event.target.value)"
        @focus="onChange"
        @blur="onBlur"
        :disbabled="disabled"></textarea>
    </div>
    <label :for="id">{{ label }}</label>
  </div>
</template>
<script>
export default {
  name: 'LennocTextArea',
  props: {
    id: {
      type: String,
      default () {
        return ''
      }
    },
    validators: {
      type: Array,
      default () {
        return []
      },
      validator (value) {
        value.forEach(vld => {
          if (
            !Object.prototype.hasOwnProperty.call(vld, 'validate') ||
            typeof vld.validate !== 'function' ||
            !Object.prototype.hasOwnProperty.call(vld, 'message') ||
            typeof vld.message !== 'string'
          ) {
            return false
          }
        })
        return true
      }
    },
    label: {
      type: String,
      default () {
        return ''
      }
    },
    value: {
      type: String,
      default () {
        return ''
      }
    },
    required: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    staticLabel: {
      type: Boolean,
      default () {
        return false
      }
    },
    domclass: {
      type: String,
      required: false,
      default () {
        return ''
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    placeholder: {
      type: String,
      required: false,
      default () {
        return ''
      }
    }
  },
  mounted () {
    this.updateValue(this.value)
  },
  data () {
    return {
      currentValue: '',
      hasFocus: false
    }
  },
  watch: {
    value () {
      this.currentValue = this.value
    }
  },
  methods: {
    updateValue: function (value) {
      this.currentValue = value
      this.$emit('input', value)
    },
    onChange () {
      this.hasFocus = true
    },
    onBlur () {
      this.hasFocus = false
    }
  },
  computed: {
    getTouchedClass () {
      return (this.staticLabel || this.currentValue) ? 'form__group--touched' : ''
    },
    getExternalClass () {
      return this.domclass
    },
    isFocused () {
      return (this.hasFocus || this.value) ? 'form__input--focus' : ''
    }
  }
}
</script>
